<template>
  <div id="app">
    <div id="progress">
      <div class="bar"></div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { getAllConfig } from "@/views/commonApi";
import { closeWebSocket } from "@/utils/ws";

export default {
  created() {
    this.getAllConfigData();
  },
  computed: {
    mes: function () {
      return this.$store.state.message;
    },
  },
  watch: {
    mes: function (val) {
      if (val && val.length > 0) {
        this.getMessage(val);
      }
    },
  },
  mounted() {

  },
  beforeDestroy() {
    closeWebSocket();
  },
  methods: {
    getMessage(message) {
      this.$confirm(
        "您有" + message.length + "条电议订单需要处理",
        "订单推送提示",

        {
          confirmButtonText: "去处理",
          cancelButtonText: "稍后处理",
          type: "warning",
        }
      )
        .then(() => {
          this.$router.push({
            path: "/OrderManagement",
            query: {
              type: "20",
            },
          });
        })
        .catch(() => {});
    },
    getAllConfigData() {
      getAllConfig().then((res) => {
        if (res.code === 200) {
          localStorage.setItem("config", JSON.stringify(res.data));
        }
      });
    },
  },
};
</script>
<style lang="scss">
#app {
  height: 100%;
  width: 100%;

  #progress {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 0.03rem;

    .bar {
      width: 0;
      height: 100%;
      background: linear-gradient(153deg, #4bcbeb 0%, #0090ff 100%);
      transition: width 1.5s linear;
    }
  }
}
</style>
